import React, {useState, useEffect, useRef} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../component/notify'
import PageHeader from '../component/pageheader'
import Select from 'react-select'
import {ServerUrl, Token, Currency, staffName, config} from '../component/include'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { longDate, FormatNumber } from '../component/globalFunction'
import { userToken } from '../component/authentication'


const FeesPayment=()=>{
	const structure = useRef(null)
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    }); 
  
const [feetype, setFeetype] =  useState([]);
const [isSubmitting, setIsSubmitting] = useState(false);  
const [studentList, setStudentList] = useState([]);
const [errors, setErrors] = useState({});
const [payment, setPayment] =  useState([]);
const [studentFee, setStudentFee]=useState({
	student:[],
	receiptNo:'',
	paymentMethod:{ value: 'BANK', label: 'BANK'},
	amountPaid:0,
	remark:'',
	paymentDate:''
});
const [fees, setFees] = useState([]);
const [feeStructure, setFeeStructure] = useState({
			structure:[], 
			feeCharge:'', 
			paid:0, 
			balance:0,
			total:0, 
			code:'', 
			classID:'', 
			sectionID:'',
			tuition_fee:'',
			school_fee:0,
			discount_percent:'',
			discountAmount:'',
			remark:'',
			fees:''
});

const generateReceipt =()=>{
	setStudentFee({...studentFee, receiptNo:Math.random().toString(36).substr(2,9).toLocaleUpperCase() })
}
const fetchStudents =()=>{
    setNotice({...notice, isLoading: true}) 
    var sql ="SELECT admissionNumber, registerNumber, studentName, classID, sectionID, code, fatherName, father_mobile from tbl_students WHERE admissionStatus = 'Studying' order by studentName ASC"

	const fd = new FormData();
	fd.append('jwt', Token);
fd.append("sql", sql);
let url = ServerUrl+'/fetchBySql_controller'
axios.post(url, fd, config).then(result=>{
    if(Array.isArray(result.data)){

		setStudentList(result.data)
	}
})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
}).finally(()=>{
    setNotice({...notice, isLoading: false})
    
})
}


const getFees=(ID)=>{
	const rs = feetype.filter(item=>item.ID===ID)

	return rs.length!==0?rs[0].fees:''
}
const  handleFetchFeeType =()=>{
	const fd = new FormData();
			fd.append('jwt', Token);
	let url = ServerUrl + '/fetch_controller/tbl_fee_type'
	axios.post(url, fd, config)
	.then(result =>setFeetype(result.data))
	.catch((error)=>{
		Alerts('Error!', 'danger', JSON.stringify(error.message)) 
	})    
		}

const fetchPayment =(student)=>{
	setNotice({...notice, isLoading: true}) 
	var sql ="SELECT CONCAT(f.sessionCode, ' ', f.feesCharge) as fees, h.code, h.amount,  h.receiptNo, h.status, h.paymentMode, h.datePaid, h.remark from tbl_fees_charge f,  tbl_fees_payment_history h where h.feesCharge = f.code and h.studentCode ='"+student+"' "

	const fd = new FormData();
	fd.append('jwt', Token);
fd.append("sql", sql);
let url = ServerUrl+'/fetchBySql_controller'
axios.post(url, fd, config).then(result=>{
	if(result.data.length!==0){
setPayment(result.data)
	}else{
		setPayment([])	
	}
})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
}).finally(()=>{
	setNotice({...notice, isLoading: false})
	
})
}


const fetchFees =(student)=>{
	setNotice({...notice, isLoading: true}) 
	
	var sql ="Select CONCAT(f.sessionCode, ' ', f.feesCharge) as fees, s.code, s.feeCharge, s.total, (select sum(h.amount) from tbl_fees_payment_history h where h.scheduleCode = s.code ) as paid  from tbl_fees_charge f, tbl_student_fees s where s.feeCharge = f.code and s.studentCode = '"+student+"' order by f.feesCharge" ;

	const fd = new FormData();
	fd.append('jwt', Token);
fd.append("sql", sql);
let url = ServerUrl+'/fetchBySql_controller'
axios.post(url, fd, config).then(result=>{
if(Array.isArray(result.data)){
		setFees(result.data)
	}else{	
		setFees([])
	} 
})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
}).finally(()=>{
	setNotice({...notice, isLoading: false})
	
})
}


const handleSelect = (option, action)=>{
	setStudentFee({...studentFee, [action.name]: option});
	setErrors({...errors, [action.name]:''})
	fetchFees(option.value)
	fetchPayment(option.value)
 }

 const handleSelectPayment = (option, action)=>{
	setStudentFee({...studentFee, [action.name]: option});
	setErrors({...errors, [action.name]:''})
 }
 const handleChange = event =>{
	let {name, value} = event.target

	if(name==='amountPaid'){
		value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
	  }
  setStudentFee({...studentFee, [name]:value})
  setErrors({...errors, [name]:''})
}



const ValidateInput =(values)=>{
    let errors = {};     
    if(Number(values.amountPaid)<=0){
        errors.amountPaid ='Please enter amount paid';
    }
    if(values.student.length===0){
        errors.student ='Please select student';
    }
    if(!values.paymentDate){
        errors.paymentDate ='Please enter payment date';
	}
	if(!values.receiptNo){
        errors.receiptNo ='Please enter receipt number';
	}
	if(!values.paymentMethod){
        errors.paymentMethod='Please select payment method';
	}
	if(Number(feeStructure.total)< Number(values.amountPaid)){
		errors.amountPaid ='Amount paid cannot be more than amount due';
		
	}
    
    return errors;
    }

const handleSubmit =(event)=>{
        event.preventDefault();
        setErrors(ValidateInput(studentFee));
        setIsSubmitting(true);
    }

    useEffect(()=>{
        if(Object.keys(errors).length === 0 && isSubmitting){
        submit()
		}
    },[errors])


	
	const fetchFeestructure =(row)=>{

		setNotice({...notice, isLoading: true}) 
		var sql ="Select feeStructure, tuition_fee, school_fee, discount_percent, discountAmount, total, feeCharge, classID, sectionID, remark from tbl_student_fees where code = '"+row.code+"'" ;
	
		const fd = new FormData();
		fd.append('jwt', Token);
	fd.append("sql", sql);
	let url = ServerUrl+'/fetchBySql_controller'
	axios.post(url, fd, config).then(result=>{

		if(result.data.length!==0){
		let data = result.data[0]
		setFeeStructure({
			structure:JSON.parse(data.feeStructure), 
			feeCharge:data.feeCharge, 
			paid:row.paid, 
			balance:Number(row.total)-Number(row.paid),
			total:data.total, 
			code:row.code, 
			classID:data.classID, 
			sectionID:data.sectionID,
			tuition_fee:data.tuition_fee,
			school_fee:data.school_fee,
			discount_percent:data.discount_percent,
			discountAmount:data.discountAmount,
			remark:data.remark,
			fees:row.fees
		
		})

		structure.current.scrollIntoView({ behavior: "smooth" });
		}
	})
	.catch((error)=>{
	Alerts('Error!', 'danger', error.message)
	}).finally(()=>{
		setNotice({...notice, isLoading: false})
		
	})
	}



		 function submit(){  
    
			var totalPaid = Number(feeStructure.paid) + Number(studentFee.amountPaid)
			var status = totalPaid>=Number(feeStructure.total)?'PAID':'PARTIAL PAYMENT'

			let formData = studentFee; 
			const fd = new FormData();
            fd.append('jwt', Token);
			for(let k in formData){
				fd.append(k,formData[k]);
			}; 

			fd.append('code', 'pt'+Math.random().toString(36).substr(2,9));
			fd.append('status', status);
			fd.append('feesCharge', feeStructure.feeCharge);
			fd.append('scheduleCode', feeStructure.code);
			fd.append('studentCode', studentFee.student.value);
			fd.append('paymentMode', studentFee.paymentMethod.value);
			fd.append('paidBy', staffName);
			fd.append('classID', feeStructure.classID);
			fd.append('sectionID', feeStructure.sectionID);
			setNotice({...notice,  isLoading: true}) 
		
				 let url = ServerUrl+'/save_controller/tbl_fees_payment_history'
				axios.post(url, fd, config)
				.then(response =>{
		 			if (response.data.type ==='success') {
						Alerts('Saved!', 'success', response.data.message)
					}  else{
						Alerts('Error!', 'danger', JSON.stringify(response.data))
				}   
						
				})
				.catch((error)=>{
					Alerts('Error!', 'danger', JSON.stringify(error.message)) 
				})
				.finally(()=>{
					setIsSubmitting(false)
					fetchFees(studentFee.student.value)
					fetchPayment(studentFee.student.value)
				  setNotice({...notice, isLoading: false})  
				 setStudentFee({...studentFee,
					receiptNo:'',
					paymentMethod:[],
					amountPaid:0,
					remark:'',
					paymentDate:''
				 })
				})   
				  
		}

		


		 const handleDelete = (feeID)=>{  
			
			   let close =   document.getElementById('btnWarningDialog-'+feeID)
				  close.click();
			 
				setNotice({...notice,  isLoading: true}) 
				const fd = new FormData();
				  fd.append('jwt', Token);
			   fd.append('ID', 'code')
				fd.append('data', feeID)
		
				let url = ServerUrl+'/delete_controller/tbl_student_fees'
			   axios.post(url, fd, config)
			   .then(response =>{
				if(response.data.type ==='success'){
				   Alerts('Saved!', 'success', response.data.message)
				   window.location.reload()
					   } else{
				   Alerts('Error!', 'danger', JSON.stringify(response.data))
					   }   
			   })
			   .catch((error)=>{
				 Alerts('Error!', 'danger', error.message)
			   }).finally(()=>{
				   setNotice({...notice, 
					   isLoading: false
				   })
			   })  
		}


	

	const tablePaymentHeader = [
		
		{dataField: 'code', text: 'Action', formatter:(cell, row)=><form method='POST' action={ServerUrl+'/printout/payment_receipt.php?token='+userToken} target='_blank'>
		
		<input type='hidden' name='slipcode' value ={cell} />
         <input type='hidden' name='jwtToken' value ={Token} />
		

		<button type='submit' className="btn btn-info btn-sm"  title='Print' > <i className="fa fa-print"></i> </button>
		</form>},
		{dataField: 'receiptNo', text: 'Receipt No'},
		{dataField: 'fees', text: 'Fees'},
		/* {dataField: 'status', text: 'Status',   formatter: (cell)=>cell==='PAID'?<span className="pcoded-badge label label-success">{cell}</span>:cell==='PARTIAL PAYMENT'? <span className="pcoded-badge label label-warning">{cell}</span>:<span className="pcoded-badge label label-danger">{cell}</span>},
		{dataField: 'paymentMode', text: 'Mode'}, */
		{dataField: 'amount', text: 'Amount ('+Currency+')',  formatter:(cell)=>FormatNumber(cell)},
		{dataField: 'remark', text: 'Remark', formatter:(cell)=><span style={{display:'block',  width:100, whiteSpace:'normal', wordWrap:'break-word' }}>{cell}</span>},
		{dataField: 'datePaid', text: 'Date Paid', formatter:(cell)=>longDate(cell)}
		
	 ];

	

	 const TablePayment=(props)=>{
	   
	const { SearchBar } = Search;
	const CustomToggleList = ({
		columns,
		onColumnToggle,
		toggles
	  }) => ( 
	  <div  className="btn-group btn-group-toggle btn-group-vertical" data-toggle="buttons">
		  {
			columns
			  .map(column => ({
				...column,
				toggle: toggles[column.dataField]
			  }))
			  .map(column => (
				
				<button
				  type="button"
				  key={ column.dataField }
				  className={ ` btn btn-primary ${column.toggle ? 'active' : ''}` }
				  data-toggle="button"
				  aria-pressed={ column.toggle ? 'true' : 'false' }
				  onClick={ () => onColumnToggle(column.dataField) }
				>
				  { column.text }
				</button>
			  ))
		  }
		</div>
		
	  );
	const customTotal = (from, to, size) => (
	<span >&nbsp;Showing { from } to { to } of { size } items</span>
	);
	const options = {
	showTotal: true,
	paginationTotalRenderer: customTotal,
	sizePerPageList: [{text: '20', value: 20}, {text: '50', value: 50}, {text: '200', value: 200}, {text: '500', value: 500}, {text: '1000', value: 1000},
	{ text: 'All', value: props.data.length }]
	
	};
	return  <ToolkitProvider search columnToggle 
				keyField='code' data={ props.data } columns={ props.columns } >
					
					{
						props => (
							<div >
						<div className="form-group">

					<SearchBar
								 { ...props.searchProps } style={{height:'40px'}} className="form-control" placeholder="Type to search!!!" />
								

	
		
	
		<div className="btn-group dropdown-split-success">
			
			<button type="button" className="btn btn-primary btn-outline-primary dropdown-toggle dropdown-toggle-split waves-effect waves-light" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			<i className="fa fa-search-plus"></i> Columns
			</button>
			
			<div className="dropdown-menu" x-placement="bottom-start" style={{overflow:'scroll', height:'220px', width:'200px', position: 'absolute', transform: 'translate3d(113px, 40px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>
			<CustomToggleList { ...props.columnToggleProps } />
			</div>
			</div>
									
				<div className="dt-buttons btn-group pull-right"> 
				<form method='POST' action={ServerUrl+'/printout/student_payments_history.php?token='+userToken} target='_blank'>
		
				<input type='hidden' name='studentCode' value ={studentFee.student.value} />
				<input type='hidden' name='jwtToken' value ={Token} />

				<button type="submit" className="btn btn-outline-primary "  > <i className="fa fa-eye"></i>Print Preview
		</button>
		</form>
		
	</div>                   
	</div>

	<BootstrapTable
				{ ...props.baseProps }
							striped
						hover
						condensed
						noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
					pagination={paginationFactory(options) }
					
				/>
			</div>
			)
					}
</ToolkitProvider>
}



		 useEffect(()=>{
			fetchStudents();
			handleFetchFeeType()
		},[]);

        return ( <>
			
			{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" } 
   <div  className="main-body">
                <div className="page-wrapper">
                 
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Fees Payment">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-money"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Fees</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Fees Payment</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

                
								<div className="row  ">
								<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Fees Payment</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">
		
										<div className="row">
										<section className="col-md-12">
									

			<div className="form-group">
						<label>Select Student <span style={{color:'red'}}>*</span></label>
						<Select  options={
                            studentList&&studentList.map((list, idx)=> {
                               return {key:idx, value: list.code, fatherName:list.fatherName, mobile:list.father_mobile, label: list.admissionNumber, studentName:list.studentName }
                             })} 
                        getOptionLabel={option =>option.label +' '+ option.studentName}

onChange={handleSelect}  name="student" value={studentFee.student}  /> 
											</div>
										</section>
									
									</div>
										
							</div>
							</div>

							</div>
		
	
	
{fees &&fees.length!==0?
	<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5>Fees List</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">
				<div className="card z-depth-0">
				<div className="card-block">
		
				<div className="row">
				<div className="col-md-12 table-responsive"> 
				
			<table className="table table-bordered">
				<thead>
					<tr>
						<th>Fees</th>
						
						<th> Due Amount ({Currency})</th>
						<th>Paid Amount ({Currency})</th>
						<th> Balance ({Currency})</th>
						<th> Action</th>
					</tr>
				</thead>
				<tbody >
					{fees.length!==0?fees.map((dat, id)=>{
					return	<tr key={id}>
					<td>{dat.fees}</td>
					<td>{FormatNumber(dat.total)}</td>
					<td>{FormatNumber(dat.paid)}</td>
					<td>{FormatNumber(Number(dat.total) - Number(dat.paid))}</td>
					<td>
					

		<form method='POST' action={ServerUrl+'/printout/student_class_fees.php?token='+userToken} target='_blank'>
		<input type='hidden' name='studentCode' value ={studentFee.student.value} />
		<input type='hidden' name='jwtToken' value ={Token} />
		<input type='hidden' name='feescharge' value ={dat.fees} />
		<input type='hidden' name='feeCharge' value ={dat.feeCharge} />
		
		<input type='hidden' name='feeCode' value ={dat.code} />

		{Number(dat.paid) < Number(dat.total)?<div><button type='button' onClick={()=>fetchFeestructure(dat)} className="btn btn-success btn-sm ml-2">Pay Now</button> &nbsp;

		<button type="button" className="btn btn-danger btn-sm " data-toggle="modal"   data-target={`#warningdialog-${dat.code}`} title="Delete"><i className="fa fa-trash"></i></button>

		<WarningModal message="This is very dangerous, you shouldn't do it! are you really really sure.?" handleAction={()=>handleDelete(dat.code)} mID={dat.code} /> 
		</div>:''}


		{Number(dat.paid) === Number(dat.total)?<button type="submit" className="btn btn-inverse btn-sm ml-2"><i className='fa fa-print'></i>Print Invoice</button>:[]}
 

		
</form>

					
					</td>
						</tr>
					}):[]}
				</tbody>
			</table>
			
			</div></div>
				
		</div></div>

{feeStructure.structure.length!==0 ?

<div>

		<div className="card z-depth-0">
				<div className="card-block">
		
				<div className="row">
				<div className="col-md-12 table-responsive"> 
				

				
{ Number(feeStructure.school_fee)>0?
<table className="table table-bordered">
				<thead>
					<tr>
						<th>Fees Charge</th>
						<th>School Fee ({Currency})</th>
						<th>Tuition Fee ({Currency})</th>
						<th>Discount ({Currency})</th>
						<th>To Pay ({Currency})</th>
					</tr>
				</thead>
				<tbody >
			<tr >
						<td>{feeStructure.fees}</td>
						<td>{FormatNumber(feeStructure.school_fee)}</td>
						<td>{FormatNumber(feeStructure.tuition_fee)}</td>
						<td>{FormatNumber(feeStructure.discountAmount)}</td>
						<td>{FormatNumber(feeStructure.total)}</td>
					</tr>
				</tbody>
				
				<tfoot>
			<tr>
				<th className='text-right' colSpan={4}>Total</th>
				<th>{FormatNumber(feeStructure.total)}</th>
			</tr>
			<tr>
				<th className='text-right' colSpan={4}>Amount to Pay</th>
				<th >{FormatNumber(feeStructure.balance)}</th>
			</tr>
		</tfoot>

			</table>:

			<table className="table table-bordered">
				<thead>
					<tr>
						<th>Fees Type</th>
						<th>Amount ({Currency})</th>
						<th>Discount ({Currency})</th>
						<th>To Pay ({Currency})</th>
					</tr>
				</thead>
				<tbody >
			{feeStructure.structure&&feeStructure.structure.map((fee, idx)=> {
                return  Number(fee.price)>0? <tr key={idx}>
						<td>{getFees(fee.ID)}</td>
						<td>{FormatNumber(fee.price)}</td>
						<td>{FormatNumber(fee.discountAmount)}</td>
						<td>{FormatNumber(Number(fee.price)-Number(fee.discountAmount))}</td>
					</tr>:[]
				})}
				</tbody>
				
				<tfoot>
			<tr>
				<th className='text-right' colSpan={3}>Total</th>
				<th>{FormatNumber(feeStructure.total)}</th>
			</tr>
			<tr>
				<th className='text-right' colSpan={3}>Amount to Pay</th>
				<th >{FormatNumber(feeStructure.balance)}</th>
			</tr>
		</tfoot>

			</table>}
			
			</div></div>
				
		</div></div>
		
		</div>:''}


		<div ref={structure} />
		{feeStructure.structure.length!==0?
		<div className="card z-depth-0">
				<div className="card-block">
		
				<div className="row">
				<div className="col-md-12 "> 
				

				<div className="form-group">
				<label> Receipt Number or Payment Reference <span style={{color:'red'}}>*</span></label>
<div className="input-group">
				<input type="text" className={errors.receiptNo?'form-control form-control-danger': 'form-control'} onChange={handleChange} name="receiptNo" value={studentFee.receiptNo} />

				<span className="input-group-addon"  id="basic-addon" onClick={generateReceipt}> <i className="fa fa-gears"></i> &nbsp;Generate Code</span><span className="required-span"> *</span>
				</div>
				<span style={{color:'red'}}>{errors.receiptNo && errors.receiptNo}</span>

            	</div>


            <div className="form-group">
         <label> Payment Method </label>
         <Select  options={[
                    { value: 'CASH', label: 'CASH' },
					{ value: 'BANK', label: 'BANK'},
					{ value: 'CHEQUE', label: 'CHEQUE'},
					{ value: 'OTHERS', label: 'OTHERS'},
                ]} 
			onChange={handleSelectPayment} className={errors.paymentMethod?'form-control form-control-danger': ''} name="paymentMethod" value={studentFee.paymentMethod}  />
 <span style={{color:'red'}}>{errors.paymentMethod && errors.paymentMethod}</span>

            </div>	 	


			<div className="form-group">
         <label> Date of Payment </label>

         <input type="date"  className={errors.paymentDate?'form-control form-control-danger': 'form-control'} onChange={handleChange} name="paymentDate" value={studentFee.paymentDate} />

		  <span style={{color:'red'}}>{errors.paymentDate && errors.paymentDate}</span>

            </div>


			<div className="form-group">
         <label> Amount Paid </label>

         <input type="text" min="0" className={errors.amountPaid?'form-control form-control-danger': 'form-control'} onChange={handleChange} onFocus={(e)=>e.target.select()} name="amountPaid" value={studentFee.amountPaid} />

		  <span style={{color:'red'}}>{errors.amountPaid && errors.amountPaid}</span>

            </div>

			<div className="form-group">
         <label> Remark </label>

		 <textarea  name="remark" className="form-control" placeholder="Remark" value={studentFee.remark} onChange={handleChange} rows="2" >{studentFee.remark}</textarea>
		  
            </div>



			
			</div></div>
				
		</div></div>:''}

		<hr/>

		{feeStructure.structure.length!==0?
<footer className="pull-right">
<button type="button" id="submit" className="btn btn-inverse " onClick={handleSubmit}>Save Payment</button>
</footer>:''}
            </div>
            </div> 
                </div>:[]} 


                </div>

{payment.length!==0?
				<div className="row">

				<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5>Paid List</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">


		<div className="col-md-12 table-responsive">
	
        <TablePayment data={payment}  columns={tablePaymentHeader} />
                </div>
            </div>
            </div> 
                </div></div>:''}


          {/* The Page Body close here */}
          
            </div>
            </div>
            </div>

</> 
 );
        
}

export default React.memo(FeesPayment) 